export default __webpack_public_path__ + "static/media/PlayStore.4cf5e004.png";